import { TableData } from '@/components/TableData/TableData';
import TableLayout from '@/layouts/TableLayout/TableLayout';

export function PaymentsBalanceContainer() {
  return (
    <TableLayout
      body={
        <TableData columnHeaders={[]} items={[]} rowItemGenerator={() => []} />
      }
    />
  );
}
